import React from "react";
import { withRouter } from "react-router-dom";
import {
    PageTitleWrapper,
    PageTitleControls,
    PageTitleHeader,
} from "ComponentsUI/PageTitleBanner";
import BreadCrumbsContainer from "Containers/BreadCrumbsContainer";
import images from "Configs/images.config";
import { observer, inject } from "mobx-react";
import { replaceStaticHost } from "Helpers/ImageManager";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import {
    DISTRICT_ONE_QUERY,
    SEARCH_HOUSE_ELASTIC_QUERY_FULL,
    SEARCH_HOUSE_QUERY_V2,
    STREET_ONE_QUERY,
} from "Services/queries";
import Routes from "Configs/routes";
import queryString from "query-string";
import WithSeoText from "Layouts/WithSeoText";
import SeoAddressContainer from "Containers/SeoAddressContainer";
import ListOfHouses from "ComponentsUI/ListOfHouses";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import { useQuery } from "react-apollo";
import SeoTextContainer from "Containers/SeoTextContainer";
import { useGetCountProviders, useGetCountTariffs } from "hooks/countQueries";

const WithBanner = props => {
    const onClickHouseHandler = () => {
        props.ApplicationModel.commonViewModel.changeShowModalOnRates(true);
        window.scroll(0, 0);
    };

    const {
        ApplicationModel: {
            compareTarifficationsModel,
            text,
            siteCode,
            routesModel,
        },
        match: {
            params: { regionUrl, districtId, streetId },
            path,
        },
        location,
    } = props;

    const windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;
    const region = props.ApplicationModel.currentRegion;
    let page = props?.match?.params?.page;
    let routeName = props?.route?.name || "";
    let filter = [];

    const districtOneQuery = useQuery(DISTRICT_ONE_QUERY, {
        skip: !props.withDistrict,
        variables: {
            id: parseInt(districtId),
        },
    });

    const districtOne = districtOneQuery?.data?.districtsOne;
    if (districtOne?.id) {
        routesModel.setDistrict(districtOne);
    }

    let streetOneQuery = useQuery(STREET_ONE_QUERY, {
        skip: !props.withStreet,
        variables: {
            id: parseInt(streetId),
        },
    });

    const streetsOne = streetOneQuery?.data?.streetsOne;
    if (!!streetsOne) {
        routesModel.setStreet(streetsOne);
    }

    let heParams = queryString.parse(location.search);
    const houseElasticQuery = useQuery(SEARCH_HOUSE_ELASTIC_QUERY_FULL, {
        skip: !props.withHouseId || !heParams.house_id,
        variables: {
            id: parseInt(heParams.house_id),
        },
    });

    const houseOneElastic = houseElasticQuery?.data?.housesOneElastic;

    if (houseOneElastic?.district_id) {
        routesModel.setHousesOneElastic(houseOneElastic);
    }

    const housesQuery = useQuery(SEARCH_HOUSE_QUERY_V2, {
        skip: !houseOneElastic?.street_id,
        variables: {
            street_id: houseOneElastic?.street_id,
            with_tariffs: 1,
        },
    });

    const houses = housesQuery?.data?.searchHousesV2?.data;

    if (region?.url) {
        filter.push(`region.url=${region.url}`);
    }
    if (routeName.includes("Operatory")) {
        filter.push("mobile_operator=1");
    } else if (routeName.includes("RatesMobile")) {
        filter.push("provider.mobile_operator=1");
    }

    let { countProviders } = useGetCountProviders(
        filter.join("&"),
        !routeName.includes("Operatory")
    );
    let { countTariffs } = useGetCountTariffs(
        filter.join("&"),
        !routeName.includes("RatesMobile")
    );

    const imagePageTitle = !!region?.image_lg
        ? {
              lg: replaceStaticHost(region.image_lg),
              md: replaceStaticHost(region.image_md),
              sm: replaceStaticHost(region.image_sm),
              xs: replaceStaticHost(region.image_xs),
          }
        : {
              lg: replaceStaticHost(images.heroBannerLg),
              md: replaceStaticHost(images.heroBannerMd),
              sm: replaceStaticHost(images.heroBannerSm),
              xs: replaceStaticHost(images.heroBannerXs),
          };

    const upper = <BreadCrumbsContainer white={!props.withoutBackground} />;

    const bottom = (
        <PageTitleHeader
            white={!props.withoutBackground}
            text={props.bannerText}
            textAfter={props.bannerTextAfter}
        />
    );

    const controllers = (
        <PageTitleControls
            button={props.buttonControllers}
            visibleControllers={compareTarifficationsModel.visibleControllers}
            leftControllerIsDisabled={!compareTarifficationsModel.currentSlide}
            leftControllerClickHandler={compareTarifficationsModel.previusSlide}
            rightControllerIsDisabled={
                compareTarifficationsModel.currentSlide +
                    compareTarifficationsModel.maxAmountCols >=
                compareTarifficationsModel.tariffs.length
            }
            rightControllerClickHandler={compareTarifficationsModel.nextSlide}
        />
    );

    let button = null;

    let marginBottom40 = false;

    const seoData = props.seoData;

    const sortHouses_ = [];

    const params = queryString.parse(location.search);

    let housesContainer;

    if (houses) {
        for (let house of houses) {
            house = house.data;
            if (house.id !== +params.house_id) {
                sortHouses_.push({
                    id: house.id,
                    name: house.full,
                    link: `${generateUrl(Routes.Rates.route, {
                        regionUrl: regionUrl,
                    })}?house_id=${house.id}`,
                    onClickHandler: () => onClickHouseHandler(house),
                });
            }
        }

        let header = `Подключенные дома по адресу`;
        if (houseOneElastic) {
            header += ` ${houseOneElastic?.street} ${houseOneElastic?.socr}`;
        }
        header += ":";
        housesContainer = (
            <Container>
                <Row>
                    <Col>
                        <ListOfHouses
                            text={text}
                            defaultItems={sortHouses_}
                            windowSizes={windowSizes}
                            showAlphabet={true}
                            type={"houses"}
                            listHeader={header}
                            isBlockLetterView={false}
                            altHeader={true}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    let seoText = seoData && seoData.main_text;

    if (
        siteCode === "101internet" &&
        props.route &&
        props.route.name === "Rates"
    ) {
        seoText = <SeoAddressContainer />;
    }

    // Если будем на роуте RatesTags или Exclusive то показываем сеотекст из контейнера
    if (
        props.route &&
        (props.route.name === "RatesTags" ||
            props.route.name === "Exclusive") &&
        (!page || page == 1)
    ) {
        seoText = (
            <SeoTextContainer
                routeName={props.route.name}
                siteCode={siteCode}
            />
        );
    }

    if (
        page ||
        (routeName.includes("Operatory") && !countProviders) ||
        (routeName.includes("RatesMobile") && !countTariffs)
    ) {
        seoText = null;
    }
    // Изменить marginBottom у картинки по ссылке Providers
    if (Routes.Providers.route == path) {
        marginBottom40 = true;
    }

    return (
        <>
            <PageTitleWrapper
                upper={!props.withoutUpper ? upper : null}
                bottom={bottom}
                background={!props.withoutBackground ? imagePageTitle : null}
                controllers={props.withControllers ? controllers : null}
                button={button}
                windowSizes={windowSizes}
                marginBottom40={marginBottom40}
                isMain={true}
            />
            <WithSeoText
                title={seoData && seoData.ttltext}
                text={seoText}
                withoutMarginTopSeoText={props.withoutMarginTopSeoText}
                faq={seoData?.faq}
                stockText={text}
            >
                {props.children}
            </WithSeoText>
            {housesContainer}
        </>
    );
};

export default withRouter(
    withDefaultParams(inject("ApplicationModel")(observer(WithBanner)))
);
